(() => {
  const BESTDEAL_CLASS = 'smartwaxx-bestdeal';

  function findRadios() {
    return Array.from(document.querySelectorAll('input[type="radio"]'));
  }

  function find4xRadio(radios) {
    return radios.find(r => ((r.value || '').toLowerCase()).includes('4x'));
  }

  function getLabelForRadio(radio) {
    // 1) Standard: label[for="id"]
    if (radio.id) {
      const byFor = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      if (byFor) return byFor;
    }
    // 2) Fallback: input steckt im label
    return radio.closest('label');
  }

  function clearBestdealMarks() {
    document.querySelectorAll(`.${BESTDEAL_CLASS}`).forEach(el => el.classList.remove(BESTDEAL_CLASS));
  }

  function markBestDeal(radio4x) {
    clearBestdealMarks();
    const lbl = getLabelForRadio(radio4x);
    if (lbl) lbl.classList.add(BESTDEAL_CLASS);
  }

  function pickBestDeal() {
    const radios = findRadios();
    if (!radios.length) return false;

    const target = find4xRadio(radios);
    if (!target) return false;

    // Klasse setzen (unabhängig davon, ob schon gewählt ist)
    markBestDeal(target);

    // Wenn schon ausgewählt: fertig
    if (target.checked) return true;

    // Prefer: Label klicken (Themes updaten UI am zuverlässigsten so)
    const lbl = getLabelForRadio(target);
    if (lbl) {
      lbl.click();
      return true;
    }

    // Fallback: direkt setzen + Events
    target.checked = true;
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function init() {
    // 1) Sofort versuchen
    if (pickBestDeal()) return;

    // 2) Delay (Themes rendern Variant-Picker manchmal später)
    setTimeout(() => {
      if (pickBestDeal()) return;

      // 3) Observer als letzte Absicherung
      const obs = new MutationObserver(() => {
        if (pickBestDeal()) obs.disconnect();
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    }, 300);
  }

  // Re-markieren, falls Theme bei Variant-Wechsel DOM neu baut
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('input[type="radio"]')) {
      // markiere 4x erneut (damit Badge/Glow bleibt)
      const radios = findRadios();
      const r4x = find4xRadio(radios);
      if (r4x) markBestDeal(r4x);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();









